<template>
  <div class="logos">
    <div v-for="logo in logos" :key="logo.url">
      <LogoComponent
        v-for="(logo, index) in logos"
        :key="logo"
        :logo="logo"
        :alt="index === 0 ? 'Financial Institution Logo' : ''"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import LogoComponent from "./Logo.vue";

export default defineComponent({
  name: "LogosComponent",
  components: { LogoComponent },

  props: {
    logos: {
      required: true,
      type: Object as PropType<string[]>,
    },
  },
});
</script>

<style scoped>
.logos {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around !important;
}
</style>
